// extracted by mini-css-extract-plugin
module.exports = {"popper":"jut__Popper__popper","hidden":"jut__Popper__hidden"};